import { createSingleAction } from 'store/utils';

const SET_OPEN_BULK_END_ASSIGNMENTS_MODAL = 'employment_management/SET_OPEN_BULK_END_ASSIGNMENTS_MODAL';
export const setOpenBulkEndAssignmentModal = createSingleAction<
boolean,
typeof SET_OPEN_BULK_END_ASSIGNMENTS_MODAL
>(
    SET_OPEN_BULK_END_ASSIGNMENTS_MODAL,
);
